import { t } from '@lingui/core/macro';
import { EmptyState } from '@pocketlaw/tetris';
export function NoResults() {
    return (<EmptyState title={t({
            message: 'No items match your search',
            comment: 'Universal search',
        })} description={t({
            comment: 'Universal search',
            message: 'We could not find any results for your search. Try to refine your search.',
        })} icon={undefined}/>);
}
